import {boxStyles} from '../Box/BoxStyles';

export const flexBoxStyles = ({inline, style = {}, ...props}: any) => {
  return {
    ...boxStyles(props),
    display: inline ? 'inline-flex' : 'flex',
    ...style,
  };
};
